import React, { useState } from 'react';
import Modal from '../../../../component/modal/Modal';
import searchIcon from '../../../../assets/image/search-status.svg';
import closeIcon from '../../../../assets/image/SingeCloseRed.svg';
import addIcon from '../../../../assets/image/plus_icon.svg';
import '../reports.scss';
import Button from '../../../../component/ui/Button';

export default function CustomizeTableColumnsModal({
	selectedColumsList,
	setSelectedColumnsList,
	availableColumnsList,
	isOpenModal,
	setIsOpenModal,
	getReportList,
	setParams,
	params,
}) {
	const [search, setSearch] = useState('');
	const [customizeColumnsList, setCustomizeColumnsList] = useState(selectedColumsList);

	const filteredAvailableList = availableColumnsList
		.filter((item) => !customizeColumnsList.some((selected) => selected.key === item.key))
		.filter((item) => !search.trim() || item.label.toLowerCase().includes(search.toLowerCase()));

	const handleAddColumn = (data) => {
		let list = [...customizeColumnsList];
		const alreadyExists = list.some((item) => item.key === data.key);
		if (!alreadyExists) {
			list.push(data);
			setCustomizeColumnsList(list);
		}
	};

	const getColumnStatus = (list1, list2) => {
		const selectedKeys = new Set(list2.map((item) => item.key));
		const result = {};
		list1.forEach((item) => {
			result[item.key] = selectedKeys.has(item.key);
		});
		return result;
	};

	const handleRemoveColumn = (data) => {
		setCustomizeColumnsList((prev) => prev.filter((item) => item.key !== data.key));
	};

	const handleApplyCustomizeColumns = () => {
		const customize_columns = getColumnStatus(availableColumnsList, customizeColumnsList);
		const updatedParams = {
			...params,
			customize_columns: JSON.stringify(customize_columns),
		};
		setSelectedColumnsList(customizeColumnsList);
		setParams(updatedParams);
		getReportList(updatedParams);
		setIsOpenModal(false);
	};

	const cancelCustomizeColumns = () => {
		getReportList();
		setIsOpenModal(false);
	};

	return (
		<div>
			<Modal
				className="customize-columns-modal"
				title={`Customize Table Columns`}
				isOpen={isOpenModal}
				onClose={() => {
					setIsOpenModal(false);
				}}
				cancelButton={() => {
					setIsOpenModal(false);
				}}
			>
				<div>
					<div className="d-flex justify-content-between gap-4">
						<div>
							<div className="fs-4 fw-bold text-secondary p-2 text-left">AVAILABLE COLUMNS</div>
							<div className="customizeColumnsRectangle p-2">
								<div
									className=" d-flex align-items-center border border-gray rounded-3 shadow-sm p-2 m-2"
									style={{ backgroundColor: '#DADDEC' }}
								>
									<img
										src={searchIcon}
										alt="search-icon"
										width="20"
										height="20"
										className="rounded-circle me-2"
									/>
									<input
										type="text"
										placeholder="Search"
										style={{ border: '0' }}
										autoComplete="off"
										value={search}
										id="search-id"
										name="search"
										onChange={(e) => setSearch(e.target.value)}
										className={`flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400`}
									/>
								</div>
								<div>
									{filteredAvailableList.map((items) => (
										<div className="d-flex justify-content-between align-items-center">
											<div className="p-2">{items.label}</div>
											<div>
												<img
													src={addIcon}
													alt="search-icon"
													width="20"
													height="20"
													className="rounded-2 me-2 cursor-pointer"
													onClick={() => handleAddColumn(items)}
												/>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
						<div>
							<div className="fs-4 fw-bold text-secondary p-2 text-left">SELECTED COLUMNS</div>
							<div className="customizeColumnsRectangle p-4">
								{customizeColumnsList.map((items) => (
									<div className="d-flex justify-content-between align-items-center">
										<div className="py-2">{items.label}</div>
										<div>
											<img
												src={closeIcon}
												alt="search-icon"
												width="20"
												height="20"
												className="rounded-2 me-2 cursor-pointer"
												onClick={() => handleRemoveColumn(items)}
											/>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="d-flex align-items-center justify-content-end my-4 gap-4">
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => {
								cancelCustomizeColumns();
							}}
						/>
						<Button
							type="button"
							button={`Apply`}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								handleApplyCustomizeColumns();
							}}
						/>
					</div>
				</div>
			</Modal>
		</div>
	);
}
